import React, { Component } from 'react'
import CSSModules from 'react-css-modules'
import Styles from './ComcastPetitionLetter.css'

@CSSModules(Styles, {allowMultiple: true})
export default class ComcastPetitionLetter extends Component {
  render() {
    return (
      <blockquote styleName='company-letter-blockquote'>
        <p><b>To: Comcast management</b></p>
        <p><b>From: <i>As You Sow</i> & concerned Comcast customers</b></p>

        <p>Investor-owned companies are profiting from exploitative prison labor, immigration jails, and other economic systems of oppression and exploitation. Mass incarceration is particularly devastating for poor communities, immigrants, people of color, and their families. As a company that directs millions of dollars in employee retirement savings towards companies profiting from the prison industrial complex, these issues expose you and your employees to a host of material risks.</p>

        <p>Critically, the default 401(k) option for Comcast employees is not invested sustainably. Over 50% of assets invested in the plan are in the default target date funds from Vanguard. Because these funds are not invested sustainably, millions of dollars in employee savings are being allocated to prison and border industry investments.</p>

        <p>Comcast has the unique opportunity to become an industry leader and help shift millions of dollars away from the prison industrial complex. You have tremendous power – and the world needs you to start using that power responsibly. I urge you to live up to your public commitments by offering a prison-free default retirement fund.</p>

        <p>Thank you.</p>

      </blockquote>
    )
  }
}
